import React from 'react';
import styled from '@emotion/styled';
import {modularScale} from '../design-system/utils';
import StyledCopy from "../design-system/typography/copy";
import theme from '../design-system/theme';

// https://developer.matomo.org/api-reference/tracking-javascript

export default class TrackingConsent extends React.PureComponent {

    constructor(props) {
        super(props);
        this.state = {showCookieConsent: false};

        if (typeof window === `undefined`) {
            return;
        }

        let isMatomoEnabled = window._paq !== undefined;

        // this.onDecisionMade = this.onDecisionMade.bind(this);

        if (isMatomoEnabled) {
            let hasAgreed = document.cookie.includes("mtm_cookie_consent");

            let self = this;
            window._paq.push([function () {
                self.state.showCookieConsent = !hasAgreed;
            }]);

            window.gtag('consent', 'update', {
                'ad_storage': hasAgreed ? 'granted' : 'denied'
            });
        }
    }

    onDecisionMade(event, hasAgreed) {
        event.preventDefault();

        if (typeof window === `undefined`) {
            return;
        }

        window.gtag('consent', 'update', {
            'ad_storage': hasAgreed ? 'granted' : 'denied'
        });

        window._paq.push([function () {
            if (hasAgreed) {
                this.rememberCookieConsentGiven();
            } else {
                this.forgetCookieConsentGiven();
            }
        }]);

        this.setState({showCookieConsent: false});
    }

    render() {
        const {textResources} = this.props;
        const {showCookieConsent} = this.state;

        return (
            showCookieConsent ?
                <StyledCookieDiv>
                    <StyledTrackingConsent>
                        <StyledCopy
                            componentType="p"
                            dangerouslySetInnerHTML={{__html: textResources["tracking_consent"]["text"]}}
                        />
                        <div className="decisionButtons">
                            <div>
                                <a className="button decline"
                                   href="#"
                                   onClick={(e) => this.onDecisionMade(e, false)}>
                                    {textResources["tracking_consent"]["disagree"]}
                                </a>
                            </div>
                            <div>
                                <a className="button agree"
                                   href="#"
                                   onClick={(e) => this.onDecisionMade(e, true)}>
                                    {textResources["tracking_consent"]["agree"]}
                                </a>
                            </div>
                        </div>
                    </StyledTrackingConsent>
                </StyledCookieDiv>
                : null
        );
    }
}

const StyledCookieDiv = styled('div')`
    min-height: 100px;
`;

const StyledTrackingConsent = styled('div')`
    position: fixed;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: #565656;
    color: #ffffff;
    
    padding: 30px 20px 40px 20px;
	gap: 25px;
    
    display: flex;
	align-items: center;
	flex-direction: column;
	
	@media (min-width: ${theme.breakpoints.tablet}px) {
	    gap: 20px;
	    padding: 40px 20px 40px 20px;
        flex-direction: row;
    }
	
    > p {
        padding: 0px;
        margin: 0px;
        width: 100%;
    }
    
    .decisionButtons {
        width: auto;
        display: flex;
        gap: 20px;
        flex-direction: row;
        justify-content: space-between;
    }
    
    .button {
        box-sizing: border-box;
	    height: 30px;
	    padding: 0.5em 1.5em;
	    display: inline;
	    align-items: center;
	    border-radius: 15px;
	    border: 2px solid #ffffff;
	    color: #ffffff;
		font-size: ${modularScale(-1.5)};
		font-weight: 600;
		letter-spacing: 0.1em;
		text-transform: uppercase;
    }
`;